import Response from '@/app/model/api/response/responseValue'
import Local from '@/app/module/local'

export default class BaseApiClient {
  public contentType = 'application/json'
  public body = null
  public useContentType = true

  public doFetch (requestpath: string, requestMethod: string) {
    const body: any = this.buildRequestBodyIfNeeded(requestMethod)
    return fetch(requestpath, body)
      .then(response => this.doResponseConvert(response))
      .then(data => this.getPayload(data))
      .catch(e => this.doError(e))
  }

  public setBody (body: any) {
    this.body = body
    return this
  }

  public donotUseContentType () {
    this.useContentType = false
    return this
  }

  public buildRequestBodyIfNeeded (requestMethod: any) {
    if (this.body !== null) {
      // ボディ作成
      if (this.useContentType) {
        return {
          method: requestMethod,
          body: this.body,
          headers: {
            'X-Auth-Token': Local.getAuthToken()!,
            'Content-Type': this.contentType
          }
        }
      } else {
        return {
          method: requestMethod,
          body: this.body,
          headers: {
            'X-Auth-Token': Local.getAuthToken()!
          }
        }
      }
    }
    return {
      method: requestMethod,
      headers: {
        'X-Auth-Token': Local.getAuthToken()!,
        'Content-Type': this.contentType
      }
    }
  }

  public setHeader (contentType: any) {
    this.contentType = contentType
    return this
  }

  public doResponseConvert (response: any) {
    if (response.status === 200) {
      return response.json()
    } else if (response.status === 400 || response.status === 401 || response.status === 403 || response.status === 404 || response.status === 409) {
      return response.json()
    } else {
      throw Error(String(response.status))
    }
  }

  public getPayload (data: any) {
    if (data.status_code === '200') {
      return new Response(true, data.payload)
    } else {
      throw data
    }
  }

  public doError (e: any) {
    // 共通のエラー処理
    if (Object.keys(e).indexOf('status_code') !== -1) {
      // ボディが存在する場合
      return new Response(false, e)
    } else {
      // ボディが存在しない場合(server errorになる)
      return new Response(false, {
        'message': 'server error'
      })
    }
  }
}
